import { Component, Input, OnInit } from '@angular/core';
import { CNConsultation } from 'src/app/models/cnconsultation';

@Component({
  selector: 'app-contact-ophtalmo-treatment',
  templateUrl: './contact-ophtalmo-treatment.component.html',
  styleUrls: ['./contact-ophtalmo-treatment.component.scss']
})

export class ContactOphtalmoTreatmentComponent implements OnInit {

  private myContact: CNConsultation;
  private prescFields = ['prescsphod', 'presccylod', 'prescaxeod', 'prescaddod', 'prescsphog', 'presccylog', 'prescaxeog',
                         'prescaddog', 'presccorsphod', 'presccorcylod', 'presccoraxeod', 'presccorsphog', 'presccorcylog',
                         'presccoraxeog'];
  private lafFields = ['lafod', 'lafog'];
  private foFields = ['fodil', 'food', 'foog'];
  private amslerFields = ['amslerod', 'amslerog'];

  public showPresc = false;
  public showLaf = false;
  public showFo = false;
  public showAmsler = false;
  public showAll = false;


  constructor() { }

  ngOnInit(): void {
  }

  @Input() set contact(theContact: CNConsultation) {
    this.myContact = theContact;
    this.prescFields.forEach(field => {
      if (typeof this.myContact.ophtalmo[field] !== 'undefined' && this.myContact.ophtalmo[field].length !== 0) {
        this.showPresc = true;
      }
    });
    this.lafFields.forEach(field => {
      if (typeof this.myContact.ophtalmo[field] !== 'undefined' && this.myContact.ophtalmo[field].length !== 0) {
        this.showLaf = true;
      }
    });
    this.foFields.forEach(field => {
      if (typeof this.myContact.ophtalmo[field] !== 'undefined' && this.myContact.ophtalmo[field].length !== 0) {
        this.showFo = true;
      }
    });
    this.amslerFields.forEach(field => {
      if (typeof this.myContact.ophtalmo[field] !== 'undefined' && this.myContact.ophtalmo[field].length !== 0) {
        this.showAmsler = true;
      }
    });

  }

  get contact(): CNConsultation {
    return this.myContact;
  }

  copy(): void {
    this.contact.ophtalmo.prescsphod = this.contact.ophtalmo.refslsphod;
    this.contact.ophtalmo.presccylod = this.contact.ophtalmo.refslcylod;
    this.contact.ophtalmo.prescaxeod = this.contact.ophtalmo.refslaxeod;
    this.contact.ophtalmo.prescaddod = this.contact.ophtalmo.refsladdod;
    this.contact.ophtalmo.prescsphog = this.contact.ophtalmo.refslsphog;
    this.contact.ophtalmo.presccylog = this.contact.ophtalmo.refslcylog;
    this.contact.ophtalmo.prescaxeog = this.contact.ophtalmo.refslaxeog;
    this.contact.ophtalmo.prescaddog = this.contact.ophtalmo.refsladdog;
    this.contact.ophtalmo.presccorsphod = this.contact.ophtalmo.refspsphod;
    this.contact.ophtalmo.presccorcylod = this.contact.ophtalmo.refspcylod;
    this.contact.ophtalmo.presccoraxeod = this.contact.ophtalmo.refspaxeod;
    this.contact.ophtalmo.presccorsphog = this.contact.ophtalmo.refspsphog;
    this.contact.ophtalmo.presccorcylog = this.contact.ophtalmo.refspcylog;
    this.contact.ophtalmo.presccoraxeog = this.contact.ophtalmo.refspaxeog;
  }

  toggleDisplayDivIfPresc() {
    this.showPresc = !this.showPresc;
  }

  toggleDisplayDivIfLaf() {
    this.showLaf = !this.showLaf;
  }

  toggleDisplayDivIfFo() {
    this.showFo = !this.showFo;
  }

  toggleDisplayDivIfAmsler() {
    this.showAmsler = !this.showAmsler;
  }



  toggleDisplayAll() {
    this.showAll = !this.showAll;
  }
}

